// extracted by mini-css-extract-plugin
export default {"cta":"Icon_cta__7wZ4a","primary":"Icon_primary__S7cmL","accessIcon":"Icon_accessIcon__LYRaE","fullAccess":"Icon_fullAccess__nIzEB","partAccess":"Icon_partAccess__Lo91f"};